import { usesNewMenu } from "@impero-com/common/navigation/newMenu";
import { useLocalUserSetting } from "@impero-com/common/utils/localUserSettings";

import { useFeatureFlag } from "../../utils/hooks/useFeatureFlag";

export const useNewMenu = (): boolean => {
    const [useOldMenuLocally] = useLocalUserSetting("useOldMenu");

    return usesNewMenu({
        newNavigationEnabled: useFeatureFlag("newNavigation"),
        useOldMenuLocally,
    });
};
